import * as types from './mutation-types'

export default {
  [types.RESET_SECTION_INDICES] (state, payload) {
    state.sectionIndices = payload
  },

  [types.CHANGE_SECTION_INDEX] (state, payload) {
    state.sectionIndices[payload.pageIndex] = payload.sectionIndex
  },
  
  [types.UPDATE_PAGE_SCALE] (state, payload) {
    state.pageScale = payload.pageScale
  },

  [types.UPDATE_VIDEO_URL] (state, payload) {
    state.videoURL = payload
  },

  [types.TOGGLE_LANGUAGES] (state) {
    if(state.activePanel == "Languages") {
      state.activePanel = ""
    }
    else {
      state.activePanel = "Languages"
    }
  },

  [types.TOGGLE_CONTENTS] (state) {
    if(state.activePanel == "Contents") {
      state.activePanel = ""
    }
    else {
      state.activePanel = "Contents"
    }
  },

  [types.TOGGLE_SEARCH] (state) {
    if(state.activePanel == "Search") {
      state.activePanel = ""
    }
    else {
      state.activePanel = "Search"
    }
  },

  [types.TOGGLE_ZOOM] (state, payload = null) {
    // console.log('toggleZoom', payload.zoomOriginX)
    if(state.zoomLevel != 1) {
      state.zoomLevel = 1
      state.zoomOriginX = 0
      state.zoomOriginY = 0
    } else {
      state.zoomLevel = payload.zoomLevel || 2
      state.zoomOriginX = payload.zoomOriginX || 0
      state.zoomOriginY = payload.zoomOriginY || 0
    }
  },
  
  [types.UPDATE_ZOOM] (state, payload) {
    state.zoomOriginX = payload.zoomOriginX
    state.zoomOriginY = payload.zoomOriginY
    state.zoomLevel = payload.zoomLevel || 2
    // console.log('update zoom', payload)
    if(state.zoomLevel < 1) state.zoomLevel = 1
  },

  [types.UPDATE_IS_DOUBLE_PAGE] (state, payload) {
    state.isDoublePage = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js